import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { Task4WorkService, TaskStatusResponse } from 'src/app/services/api/task4work/task4work.service';

@Component({
  selector: 'app-cancel-installation',
  templateUrl: './cancel-installation.component.html',
  styleUrls: ['./cancel-installation.component.scss']
})
export class CancelInstallationComponent implements OnInit {

  loading: boolean;

  private subscriptions = new Subscription();

  constructor(
    private task4WorkService: Task4WorkService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private dialogRef: MatDialogRef<CancelInstallationComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      externalId: string;
    },
  ) {
  }

  ngOnInit() {
    this.loading = false;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  cancelInstallation() {
    this.loading = true;
    this.task4WorkService.cancelTask(this.data.externalId.split('_')[1]).subscribe(
      (data: TaskStatusResponse) => {
        this.notificationsService.showNotification(this.translateService.instant('CANCEL_INSTALLATION.success'), NotificationLevel.SUCCESS);
        this.loading = false;
        this.dialogRef.close(true);
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('CANCEL_INSTALLATION.error'), NotificationLevel.ERROR);
        this.loading = false;
      }
    );
  }

}
